import React, { lazy, Suspense } from 'react';

const LazyAboutPage = lazy(() => import('./ServicePage'));

const ServicePage = (props: JSX.IntrinsicAttributes & { children?: React.ReactNode; }) => (
  <Suspense fallback={null}>
    <LazyAboutPage {...props} />
  </Suspense>
);



export default ServicePage;
